import axios, {AxiosResponse} from 'axios'
import {SuspectRoleQueryResponse} from './_model'

const API_URL = process.env.REACT_APP_BASE_API_URL
const URL = `${API_URL}/suspectRoles`

const getSuspectRole = (query: string): Promise<SuspectRoleQueryResponse> => {
  return axios.get(`${URL}?${query}`).then((d: AxiosResponse<SuspectRoleQueryResponse>) => d.data)
}

export {getSuspectRole}
